import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export const WhoWeAre = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
  }, []);

  return (
    <div className="info-container">
      <div className="who-we-are-container">
        <div className="information-first-container" data-aos="fade-zoom-in">
          <p className="information-opening">
            CANVAS for Works© is a collaborative design practice established to
            reimagine archetypal communication within contemporary media to
            produce a more positively transformative kind; by navigating the
            lines between different disciplines, we exist to produce good media,
            for good works.
          </p>
          <div className="information-second-container">
            <div className="information-content">
              <p>
                The name is inspired by the very genesis of the company; it
                serves as more of a description. CANVAS for Works© abides in the
                essence of the Hebrew noun, <i>avodah</i> - the ideal that work
                and service are intertwined, being one in the same.
                <br />
                <br />
                Good works represents good service to the world. With the goal
                to infiltrate culture to promote healthy thinking, we explore
                interdisciplinary borders, collaborating across different
                disciplines, or canvases, to communicate key messages.
                <br />
                <br />
                These are the shared ideals that we look for when working with
                partners &amp; collaborators.
                <br />
                <br />
                Purpose is in creation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
